import { Grid, styled } from "@mui/material";

const DialogGridText = styled(Grid)(() => ({
    alignSelf: "center",
}));

export default DialogGridText